export class Note
{

	noteId: number;
}
